import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import VideoPlayButton from './buttons/VideoPlayButton'
import VideoVolumeButton from 'aria-viewer/players/videoplayer/containers/buttons/simpleVideoVolumeButton.js'
import ScrubBar from './bars/simpleVideoScrubBar'
import mobileDetect from 'aria-viewer/utils/mobileDetect'
import { PLATFORM } from 'aria-viewer/tour/constants/'
import { VIDEO_PLAY_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { VideoPlayer } from '../../../legacy'
import pure from 'recompose/pure'

// Torch this code with gasoline at the earliest opportunity

const settingsButtonStyle = {
    position: 'absolute',
    top: '40%',
    width: '22px',
    height: '22px',
    transform: 'translateZ(1px)',
    pointerEvents: 'all',
}

const Style = {
    mobile: {
        uiContainer: {
            position: 'absolute',
            width: '100%',
            top: '24%',
            height: '60%',
        },
        skipButton: {
            position: 'absolute',
            right: '0',
            bottom: '0',
            pointerEvents: 'all',
        },
        centerPlayButton: {
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, 0%, 1px)',
            width: '102.4px',
            height: '102.4px',
            pointerEvents: 'all',
        },
        hidePlayButton: {
            position: 'absolute',
            opacity: '0',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, 0%, 1px)',
            width: '102.4px',
            height: '102.4px',
        },
        volumeButton: {
            ...settingsButtonStyle,
            display: mobileDetect.mobile() ? 'none' : 'initial',
            left: '8%',
        },
        qualityButton: {
            ...settingsButtonStyle,
            right: '8%',
        },
        scrubContainer: isWalkingtour => null,
        scrubBar: isWalkingtour => ({
            position: 'absolute',
            left: '50%',
            bottom: isWalkingtour ? '28%' : '15%',
            transform: 'translate(-50%) translateZ(1px)',
            width: '83.5%',
            pointerEvents: 'all',
        }),
        scrubBarHeight: 4,
        qualityOffsetY: -50,
    },
    desktop: {
        uiContainer: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: '550px',
            top: '550px',
            zIndex: 2005,
            pointerEvents: 'none',
        },
        skipButton: {
            position: 'absolute',
            right: '0',
            bottom: '0.4em',
        },
        playButton: {
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translateY(-50%) translateZ(1px)',
            width: 50,
            height: 50,
            cursor: 'pointer',
        },
        centerPlayButton: {
            position: 'fixed',
            cursor: 'pointer',
            top: '50%',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 1px)',
            pointerEvents: 'all',
            width: '110px',
            height: '110px',
        },
        hidePlayButton: {
            position: 'absolute',
            opacity: '0',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 1px)',
            width: '102.4px',
            height: '102.4px',
        },
        playButtonStrokeWidth: 0,
        playButtonFill: 'none',
        volumeButton: {
            ...settingsButtonStyle,
            right: '25px',
            top: '30%',
            width: '18px',
            height: '18px',
            padding: '25px 0px 0px 0px',
            background: 'rgba(8, 19, 30, 0)',
            cursor: 'pointer',
            transform: 'translateY(-50%) translateZ(1px)',
        },
        qualityButton: {
            ...settingsButtonStyle,
            right: '55px',
            top: '50%',
            width: '18px',
            height: '18px',
            padding: '0px',
            background: 'rgba(8, 19, 30, 0)',
            cursor: 'pointer',
            transform: 'translateY(-50%) translateZ(1px)',
        },
        scrubContainer: isWalkingtour => ({
            position: 'fixed',
            left: '50%',
            bottom: '10px',
            transform: 'translate(-50%) translateZ(1px)',
            background: 'rgba(8, 19, 30, 0.5)',
            borderRadius: '18px',
            width: '620px',
            height: '60px',
            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.5)',
            pointerEvents: 'all',
        }),
        scrubBar: isWalkingtour => ({
            position: 'relative',
            width: '476px',
            top: '25px',
            left: '60px',
            videoDuration: { fontSize: '14px' },
        }),
        scrubBarHeight: 2,
        scrubBarMarkerWidth: 2,
        scrubBarMarkerHeight: 14,
        scrubBarMarkerTop: -12,
        qualityOffsetY: -36,
    },
}

const preventEventBubbling = e => {
    e && e.stopPropagation && e.stopPropagation()
    e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
    e && e.preventDefault && e.preventDefault()
}

const VideoUIControls = function VideoUIControls({ isWalkingtour, platformUsed, onChange, player }) {
    return (
        <div onClick={preventEventBubbling} id="video_ui_control_buttons">
            <VideoVolumeButton
                onChange={onChange}
                style={Style[platformUsed].volumeButton}
                theme={platformUsed}
                volumeHeight={platformUsed == PLATFORM.desktop ? 85 : null}
                player={player}
                seconds={player.getProgressInfo().seconds}
            />
            {/* <VideoQualityButton
                onClick={onChange}
                style={Style[platformUsed].qualityButton}
                offsetY={Style[platformUsed].qualityOffsetY}
            /> */}
            <ScrubBar
                onChange={onChange}
                style={Style[platformUsed].scrubBar(isWalkingtour)}
                height={Style[platformUsed].scrubBarHeight}
                markerWidth={Style[platformUsed].scrubBarMarkerWidth}
                markerHeight={Style[platformUsed].scrubBarMarkerHeight}
                markerTop={Style[platformUsed].scrubBarMarkerTop}
                player={player}
                progress={Object.assign({}, player.getProgressInfo())}
                percent={Number.parseFloat(player.getProgressInfo().percent)}
            />
        </div>
    )
}

const Theme = {
    modal: {
        mobile: {
            container: videoType => ({}),
            scrubContainer: () => ({
                bottom: 5,
                background: 'transparent',
                boxShadow: 'none',
            }),
            uiContainer: Object.assign({}, Style.mobile.uiContainer, {
                top: '0',
                height: '100%',
            }),
            playButton: Object.assign({}, Style.mobile.playButton, {
                top: '50%',
                transform: 'translate3d(-50%, -50%, 1px)',
            }),
        },
        desktop: {
            scrubContainer: isWalkingtour =>
                Object.assign({}, Style.desktop.scrubContainer(isWalkingtour), {
                    bottom: '32px',
                    overflow: 'visible',
                }),
        },
    },
}

class VideoPlayerUI extends PureComponent {
    constructor(props) {
        super(props)

        this.R = { videoUIControls: undefined }
        this.state = { show360VideoPlayButton: false } //intro video play button shows on 360 trigger videos
    }
    static propTypes = {
        player: PropTypes.object.isRequired,
        platform: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        onControlsHover: PropTypes.func,
        onControlsHoverEnd: PropTypes.func,
    }

    static defaultProps = {
        platform: { theme: PLATFORM.mobile },
    }

    componentDidMount() {
        const { onControlsHoverEnd, player } = this.props
        const isMobileIntroVideo =
            platform === PLATFORM.mobile &&
            (player.options.contextType && player.options.contextType === MediaContextTypes.INTRO_VIDEO)

        if (this.R.videoUIControls) {
            this.R.videoUIControls.addEventListener('mouseleave', onControlsHoverEnd)
        }

        this.pollingInterval = setInterval(() => {
            this.setState({ progressInfo: player ? player.getProgressInfo() : null })
        }, 1000)

        !isMobileIntroVideo &&
            (this.videoPlayButtonTimeout = setTimeout(() => {
                this.setState({ show360VideoPlayButton: true })
            }, 250))
    }

    componentWillMount() {
        const {
            theme: { platform, containerTheme, videoType },
            style,
        } = this.props

        this.theme = Object.assign(
            {},
            style,
            Theme[containerTheme] &&
                Theme[containerTheme][platform].container &&
                Theme[containerTheme][platform].container(videoType)
        )
    }

    componentWillUnmount() {
        const { onControlsHoverEnd } = this.props

        clearTimeout(this.videoPlayButtonTimeout)
        clearInterval(this.pollingInterval)

        if (this.R.videoUIControls) {
            this.R.videoUIControls.removeEventListener('mouseleave', onControlsHoverEnd)
        }
    }

    handleChange = e => {
        const { onChange } = this.props

        preventEventBubbling(e)
        onChange && onChange()
    }

    handlePlayButtonClick = e => {
        const { isVideoPlaying, onPlay, onPause } = this.props

        preventEventBubbling(e)

        isVideoPlaying ? onPause() : onPlay()
    }

    getCustomStyle = ({ customTheme, platform, style, playerType }) => {
        if (
            (playerType == VideoPlayer.types.YOUTUBE || playerType == VideoPlayer.types.VIMEO) &&
            style == 'uiContainer'
        ) {
            return { display: 'none' }
        }
        return (customTheme && customTheme[platform] && customTheme[platform][style]) || Style[platform][style]
    }

    render() {
        const { progressInfo } = this.state
        const {
            isWalkingtour,
            theme: { platform, containerTheme, hideControls },
            isVideoPlaying,
            onControlsHover,
            player,
        } = this.props

        const { show360VideoPlayButton } = this.state

        const customTheme = Theme[containerTheme]
        const hideMobileUIControls = platform == PLATFORM.mobile && player.type == VideoPlayer.types.YOUTUBE
        const hideCenterPlay =
            platform == PLATFORM.desktop && (isVideoPlaying || player.type == VideoPlayer.types.YOUTUBE)
        const platformUsed = platform.theme ? platform.theme : platform
        const containerStyle = this.getCustomStyle({
            customTheme,
            platform,
            style: 'uiContainer',
            playerType: player.type,
        })
        return (
            <div style={this.theme} id="video_ui_wrapper">
                <div
                    style={containerStyle}
                    ref={c => (this.R.videoUIControls = c)}
                    onMouseEnter={onControlsHover} // HIDE TEMPORARILY
                >
                    {show360VideoPlayButton && platform == PLATFORM.mobile && (
                        <VideoPlayButton
                            isVideoPlaying={isVideoPlaying}
                            tabIndex={VIDEO_PLAY_BUTTON_INDEX}
                            onClick={e => this.handlePlayButtonClick(e)}
                            buttonStyle={this.getCustomStyle({
                                customTheme,
                                platform,
                                style: !hideCenterPlay ? 'centerPlayButton' : 'hidePlayButton',
                            })}
                            strokeWidth={Style[PLATFORM.mobile].playButtonStrokeWidth}
                            seconds={progressInfo ? progressInfo.seconds : player.getProgressInfo().seconds}
                        />
                    )}
                    <div style={(customTheme || Style)[platform].scrubContainer(isWalkingtour)}>
                        {platform == PLATFORM.desktop && (
                            <VideoPlayButton
                                tabIndex={VIDEO_PLAY_BUTTON_INDEX}
                                onClick={e => this.handlePlayButtonClick(e)}
                                buttonStyle={Style[platform].playButton}
                                strokeWidth={Style[platform].playButtonStrokeWidth}
                                isVideoPlaying={isVideoPlaying}
                                fill={Style[platform].playButtonFill}
                                progress={progressInfo ? progressInfo : player.getProgressInfo()}
                                seconds={progressInfo ? progressInfo.seconds : player.getProgressInfo().seconds}
                            />
                        )}
                        {!hideControls && !hideMobileUIControls && (
                            <VideoUIControls
                                onChange={this.handleChange}
                                isWalkingtour={isWalkingtour}
                                platformUsed={platformUsed}
                                isVideoPlaying={isVideoPlaying}
                                player={player}
                                progress={progressInfo ? progressInfo : player.getProgressInfo()}
                                seconds={progressInfo ? progressInfo.seconds : player.getProgressInfo().seconds}
                                percent={progressInfo ? progressInfo.percent : player.getProgressInfo().percent}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoPlayerUI
